<template>
  <el-select
    v-model="selectValue"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    :filterable="filterable"
    :clearable="clearable"
    @change="onChange"
  >
    <el-option
      v-for="item in selectOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import {
  createVNode,
  defineComponent,
  onMounted,
  toRefs,
  getCurrentInstance,
  reactive,
  ref,
  watch,
} from "vue";
import { replaceObjectKeys } from "@pansy/utils";
import selectMixin from "./selectMixin";
export default defineComponent({
  name: "sSelect",
  mixins: [selectMixin],
  props: {},
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      selectOptions: [],
      selectValue: null,
    });

    // 获取下拉选项
    const getData = (obj) => {
      if (props.url) {
        proxy.$api[props.url]({ ...props.params, ...obj }).then((res) => {
          const data = res.data;
          state.selectOptions = props.field
            ? replaceObjectKeys(data, props.field)
            : data;
        });
      } else if (props.options && props.options.length > 0) {
        state.selectOptions = props.field
          ? replaceObjectKeys(props.options, props.field)
          : props.options;
      }
    };

    onMounted(() => {
      if (props.multiple) {
        state.selectValue = props.modelValue
          ? props.modelValue instanceof Array
            ? props.modelValue
            : props.modelValue.split(",")
          : [];
      } else {
        state.selectValue = props.modelValue;
      }

      getData();
    });

    watch(
      () => props.modelValue,
      (n) => {
        if (props.multiple) {
          state.selectValue = n ? (n instanceof Array ? n : n.split(",")) : [];
        } else {
          state.selectValue = n;
        }
      }
    );

    watch(
      () => props.params,
      (n) => {
        getData();
      }
    );
    watch(
      () => props.options,
      (n) => {
        if (!props.url) {
          getData();
        }
      }
    );

    const onChange = (value, option) => {
      if (props.multiple) {
        emit("update:modelValue", state.selectValue.join(","));
      } else {
        emit("update:modelValue", state.selectValue);
      }
      emit("change-check", value, option);
    };

    return {
      ...toRefs(state),
      onChange,
      getData,
    };
  },
});
</script>
<style lang="less">
.g-select {
  &.ant-select {
    width: 218px;
  }
}
</style>
